import React from 'react';
import { CheckIcon } from 'lucide-react';
import { caseStatuses } from '../../types/admin';
import type { CaseStatus } from '../../types/admin';
export function StatusTimeline({
  status
}: {
  status: CaseStatus;
}) {
  const current = caseStatuses.indexOf(status);
  return <ol className="flex gap-1 overflow-x-auto pb-1" aria-label="Sagens forløb" data-id="element-196" data-mp="29krsabgj7y6y">
      {caseStatuses.map((step, index) => {
      const done = index < current;
      const active = index === current;
      return <li key={step} className="min-w-[88px] flex-1" data-id="element-197" data-mp="1gvkk0kr9zu8i" data-mpi={index}>
            <div className="flex items-center gap-1.5" data-id="element-198" data-mp="1gy6qsi6ce5po">
              <span className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-[11px] font-semibold transition-colors duration-200 ease-smooth ${done ? 'border-ink bg-ink text-white' : active ? 'border-accent bg-accent text-white' : 'border-line bg-white text-ink-faint'}`} data-id="element-199" data-mp="1lu45yl5vd60v">
                {done ? <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-200" data-mp="2slwvzoedd4of" /> : index + 1}
              </span>
              {index < caseStatuses.length - 1 && <span className={`h-px flex-1 ${done ? 'bg-ink' : 'bg-line'}`} aria-hidden="true" data-id="element-201" data-mp="2nkr1pm5299cs" />}
            </div>
            <p className={`mt-2 text-xs leading-snug ${active ? 'font-semibold text-ink' : done ? 'text-ink-soft' : 'text-ink-faint'}`} data-id="element-202" data-mp="2elvuc6qa5t7w">
              {step}
              {active && <span className="sr-only" data-id="element-203" data-mp="24vb16ytdlgwd"> (nuværende status)</span>}
            </p>
          </li>;
    })}
    </ol>;
}